<template>
<div>edit group</div>
</template>

<script>
export default {
  name: 'PeronEditReservationGroup',
}
</script>

<style scoped>

</style>
